import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { setCulture } from 'services/others';
import { langsMap } from 'consts';
import { queryClient } from 'config/query-client';

import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useLanguageContext } from '../../contexts/Localization';
import { LANGUAGES } from 'events/types';
import { ERefetchType } from 'enums';

const LanguageDropdown = () => {
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [selectedLangId, setSelectedLangId] = useState('en');
  const [langInStorage, setLangInStorage] = useLocalStorage('language', 'en');
  // @ts-ignore
  const { language, changeLanguage } = useLanguageContext();

  useEffect(() => {
    setSelectedLangId(language);
  }, [language]);

  useEffect(() => {
    if (langInStorage) {
      setSelectedLangId(langInStorage);
      changeLanguage(langInStorage);
    }
  }, [langInStorage, changeLanguage]);

  const { mutate: postLang } = useMutation(setCulture, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [LANGUAGES],
        refetchType: ERefetchType.ALL,
      });
    },
  });

  const handleLangChange = (lang: string) => {
    setSelectedLangId(lang);
    setdropdownOpen(false);
    setLangInStorage(lang);
    changeLanguage(lang);

    postLang(lang);
  };

  return (
    <div className="flex items-center gap-x-3">
      <div className="relative font-markpro">
        <div
          onClick={() => setdropdownOpen(!dropdownOpen)}
          className="flex h-[38px] cursor-pointer items-center 
          justify-center rounded-[21px] bg-[rgba(247,249,252,1)] p-[12px] text-[16px] font-normal transition-all hover:bg-gray-100"
        >
          {selectedLangId?.toUpperCase()}
        </div>
        <div
          className={`${
            dropdownOpen
              ? `visible top-[calc(100%+20px)] opacity-100`
              : 'invisible top-[110%] opacity-0'
          } absolute left-[-140px] right-0 z-50 w-fit min-w-[171px] rounded-md border border-[#292D320F] bg-white text-[#222] transition-all`}
        >
          {langsMap?.map(({ key, value }) => (
            <div
              onClick={() => handleLangChange(key)}
              key={key}
              className="flex cursor-pointer items-center p-[14px] hover:bg-gray-100"
            >
              <span>{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageDropdown;
